export default [
  {
    path: "/lucky",
    component: () => import("@/pages/lucky"),
    meta: {
      title: "抽奖",
    },
  },
  {
    path: "/lucky/record",
    component: () => import("@/pages/lucky/record"),
    meta: {
      title: "我的参与记录",
    },
  },
  {
    path: "/lucky/rule",
    component: () => import("@/pages/lucky/rule"),
    meta: {
      title: "活动规则",
    },
  },
];
